import { Link } from 'react-router-dom';
import HeaderLine from '../font/headerline';
import Header from '../font/header1';
import Header2 from '../font/header2';

const featuredCities = [
    { slug: 'atlanta', cityName: 'Atlanta' },
    { slug: 'charlotte', cityName: 'Charlotte' },
    { slug: 'nashville', cityName: 'Nashville' },
    { slug: 'new-york', cityName: 'New York' },
    { slug: 'chicago', cityName: 'Chicago' },
    { slug: 'houston', cityName: 'Houston' },
    { slug: 'austin', cityName: 'Austin' },
    { slug: 'phoenix', cityName: 'Phoenix' },
    { slug: 'los-angeles', cityName: 'Los Angeles' },
    { slug: 'seattle', cityName: 'Seattle' },
    { slug: 'denver', cityName: 'Denver' },
    { slug: 'miami', cityName: 'Miami' },
];

const LocationsTeaser = () => {
    return (
        <div className='flex flex-col justify-center pt-16 lg:pt-24 lg:p-10'>
            <div className='flex flex-row'>
                <HeaderLine />
                <div className='flex flex-col place-items-center flex-1 lg:flex-none w-full lg:w-auto px-4'>
                    <Header>Locations We Serve</Header>
                </div>
                <HeaderLine />
            </div>
            <Header2>HomeButler's Home Operating System, built for your city's climate</Header2>
            <div className='flex flex-row flex-wrap justify-center gap-x-6 gap-y-3 px-6 pt-4'>
                {featuredCities.map((city) => (
                    <Link
                        key={city.slug}
                        to={`/locations/${city.slug}`}
                        className='text-darkblue hover:text-blue underline underline-offset-4'
                    >
                        {city.cityName}
                    </Link>
                ))}
            </div>
            <Link to='/locations' className='text-blue hover:text-darkblue font-semibold text-center pt-6'>
                See all locations &rarr;
            </Link>
        </div>
    );
};

export default LocationsTeaser;
